// Crm campaign events
export const APP_RESPONSE = 'App.Response';
export const APP_INTERACT = 'App.Interact';
export const APP_POPUP = 'App.Popup';
